import { SectionPageHeader } from '@ingenico/react-section-utils';
import type { ReactNode } from 'react';
import { useSyncConfigurationPageVM } from './useSyncConfigurationPage.vm';
import { SyncConfigurationPageContent } from '../../components/sync-configuration-page-content/SyncConfigurationPageContent.ctrl';

export function SyncConfigurationPage(): ReactNode {
  const { pageTitle, isMobile } = useSyncConfigurationPageVM();

  return (
    <>
      {!isMobile && <SectionPageHeader title={pageTitle} />}
      <SyncConfigurationPageContent />
    </>
  );
}
